/**
 * AI-3 — the ONE authority for the deal → «دستیار تحلیل» deep-link seed wording.
 *
 * The deal screen's analyst button fills (does NOT auto-send) the chat composer with a natural-language
 * question about the open deal, so an Admin who lives on the deal screen can hand it to the analyst without
 * retyping context. Two rules this function enforces, both load-bearing:
 *
 *   1. It names the deal's BUSINESS number (`deal.no`) — the handle `get_deal` resolves by — and NEVER the
 *      internal `deal.id` (AI-2: this string is model-visible; internal ids must not reach the model).
 *   2. It only FILLS the box; the human presses ارسال. So this is plain text, mirroring the STARTERS chips'
 *      tone (AiChatScreen.tsx) — no send-path fork, and the human review before any model spend is kept.
 */
export function dealAnalysisSeed(no: string): string {
  return `قرارداد ${no} را تحلیل کن: حاشیه، ریسک و نکات مهم آن چیست؟`;
}
